// src/pages/Settings.js
import React, { useState } from "react";
import {
  Typography,
  Paper,
  Grid,
  Box,
  Switch,
  FormControlLabel,
  Divider,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Card,
  CardContent,
  CardHeader,
  Snackbar,
  Alert,
} from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";

const Settings = () => {
  const [success, setSuccess] = useState(false);
  const [settings, setSettings] = useState({
    notifications: {
      email: true,
      app: true,
      sms: false,
    },
    preferences: {
      theme: "light",
      language: "en",
      timezone: "America/Los_Angeles",
    },
    security: {
      twoFactorAuth: false,
      sessionTimeout: 30,
    },
  });

  const handleSwitchChange = (section, name) => (event) => {
    setSettings({
      ...settings,
      [section]: {
        ...settings[section],
        [name]: event.target.checked,
      },
    });
  };

  const handleInputChange = (section, name) => (event) => {
    setSettings({
      ...settings,
      [section]: {
        ...settings[section],
        [name]: event.target.value,
      },
    });
  };

  const handleSaveSettings = () => {
    // Simulate saving settings
    setTimeout(() => {
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    }, 500);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Grid container spacing={3}>
        <Grid  size={{ xs: 12, md: 6 }}>
          <Card elevation={2} sx={{ mb: 3 }}>
            <CardHeader title="Notification Settings" />
            <Divider />
            <CardContent>
              <FormControlLabel
                control={
                  <Switch
                    checked={settings.notifications.email}
                    onChange={handleSwitchChange("notifications", "email")}
                    color="primary"
                  />
                }
                label="Email Notifications"
              />
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
                gutterBottom
              >
                Receive notifications about new orders, route assignments, and
                updates via email
              </Typography>

              <FormControlLabel
                control={
                  <Switch
                    checked={settings.notifications.app}
                    onChange={handleSwitchChange("notifications", "app")}
                    color="primary"
                  />
                }
                label="In-app Notifications"
              />
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
                gutterBottom
              >
                Receive notifications within the application
              </Typography>

              <FormControlLabel
                control={
                  <Switch
                    checked={settings.notifications.sms}
                    onChange={handleSwitchChange("notifications", "sms")}
                    color="primary"
                  />
                }
                label="SMS Notifications"
              />
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
              >
                Receive important notifications via text message
              </Typography>
            </CardContent>
          </Card>

          <Card elevation={2}>
            <CardHeader title="Security Settings" />
            <Divider />
            <CardContent>
              <FormControlLabel
                control={
                  <Switch
                    checked={settings.security.twoFactorAuth}
                    onChange={handleSwitchChange("security", "twoFactorAuth")}
                    color="primary"
                  />
                }
                label="Two-factor Authentication"
              />
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
                gutterBottom
              >
                Add an extra layer of security to your account
              </Typography>

              <Box mt={3}>
                <FormControl fullWidth>
                  <InputLabel>Session Timeout (minutes)</InputLabel>
                  <Select
                    value={settings.security.sessionTimeout}
                    onChange={handleInputChange("security", "sessionTimeout")}
                    label="Session Timeout (minutes)"
                  >
                    <MenuItem value={15}>15 minutes</MenuItem>
                    <MenuItem value={30}>30 minutes</MenuItem>
                    <MenuItem value={60}>1 hour</MenuItem>
                    <MenuItem value={120}>2 hours</MenuItem>
                    <MenuItem value={240}>4 hours</MenuItem>
                  </Select>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ mt: 1 }}
                  >
                    Automatically log out after inactivity
                  </Typography>
                </FormControl>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          onClick={handleSaveSettings}
        >
          Save Settings
        </Button>
      </Box>

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={() => setSuccess(false)} severity="success">
          Settings saved successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Settings;
